import { ApolloMatchesDialog } from 'legacy/lut/components/common/apolloSearch/components/apolloMatchesDialog/ApolloMatchesDialog'
import {
  IClasses,
  TPartnerDuplicatesContentAction,
  TPartnerDuplicatesContentMessage,
  TPartnerDuplicatesHeaderAction,
  TPartnerDuplicatesHeaderMessage,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import React, { memo } from 'react'

import { IPartner, IPartnerDuplicate, TPartnerDifference } from 'clickNgo/entities/partner/models'
import { Button } from 'core-components/library/button'

interface IApolloSearchProps {
  partnerDuplicatesContentActions: TPartnerDuplicatesContentAction[]
  partnerDuplicatesContentMessages: TPartnerDuplicatesContentMessage[]
  partnerDuplicatesHeaderMessages: TPartnerDuplicatesHeaderMessage[]
  partnerDuplicatesHeaderActions: TPartnerDuplicatesHeaderAction[]
  isDisabled?: boolean
  onPartnerSearchInApollo: () => void
  apolloResult: IPartnerDuplicate[]
  resetApolloResult: () => void
  isVisible: boolean
  styleClasses?: IClasses
  sortDifference?: (a: TPartnerDifference, b: TPartnerDifference) => number
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
}

export const ApolloSearch = memo(
  ({
    partnerDuplicatesContentActions,
    partnerDuplicatesContentMessages,
    partnerDuplicatesHeaderMessages,
    isDisabled,
    onPartnerSearchInApollo,
    partnerDuplicatesHeaderActions,
    apolloResult,
    resetApolloResult,
    isVisible,
    sortDifference,
    onPartialReplace,
  }: IApolloSearchProps) => {
    return (
      <div>
        <Button onClick={onPartnerSearchInApollo} disabled={isDisabled}>
          {`Apollo Search`}
        </Button>
        <ApolloMatchesDialog
          isVisible={isVisible}
          duplicates={apolloResult}
          onClose={resetApolloResult}
          onPartialReplace={onPartialReplace}
          headerActions={partnerDuplicatesHeaderActions}
          contentActions={partnerDuplicatesContentActions}
          contentMessages={partnerDuplicatesContentMessages}
          headerMessages={partnerDuplicatesHeaderMessages}
          sortDifference={sortDifference}
        />
      </div>
    )
  }
)
